import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'company-hub.carousel-extension.config-panel.title',
		defaultMessage: 'Carousel',
		description: 'A visible text label to be used as the title for the carousel config panel',
	},
	framesInvalidMessage: {
		id: 'company-hub.carousel-extension.config-panel.field.frames.error.invalid-list',
		defaultMessage: 'Add frames',
		description:
			'Message for error shown to user when a value for frames is not provided or is invalid',
	},
	preambleV2: {
		id: 'company-hub.carousel-extension.config-panel.preamble-v2',
		defaultMessage: 'Design a set of up to {number} rotating frames. {supportLink}',
		description: 'General helper text in Company hub configuration panel',
	},
	preambleV2WithoutSupportLink: {
		id: 'company-hub.carousel-extension.config-panel.preamble-v2-without-support-link',
		defaultMessage: 'Design a set of up to {number} rotating frames.',
		description: 'General helper text in Company hub configuration panel without support link',
	},
	preambleSupportLinkLabelV2: {
		id: 'company-hub.carousel-extension.config-panel.preamble-link.label-v2',
		defaultMessage: 'Learn more about carousels',
		description:
			'Link text to learn more about carousel. Located in the general helper text in carousel config panel',
	},
	stylesTabLabel: {
		id: 'company-hub.carousel-extension.config-panel.tab.styles.label',
		defaultMessage: 'Styles',
		description: 'Styles tab pill label',
	},
	contentTabLabel: {
		id: 'company-hub.carousel-extension.config-panel.tab.content.label',
		defaultMessage: 'Content',
		description: 'Content tab pill label',
	},
	styleSectionGeneralTitle: {
		id: 'company-hub.carousel-extension.config-panel.style.general.title',
		defaultMessage: 'General',
		description: 'Title for the general style section in the carousel config panel',
	},
	styleSectionNavigationTitle: {
		id: 'company-hub.carousel-extension.config-panel.style.navigation.title',
		defaultMessage: 'Navigation',
		description: 'Title for the navigation style section in the carousel config panel',
	},
	addFrameText: {
		id: 'company-hub.carousel-extension.config-panel.add-frame-cta',
		defaultMessage: 'Add frame',
		description: 'Button that allows the user to add a new frame to their carousel extension',
	},
	updatedLozengeLabel: {
		id: 'company-hub.carousel-extension.config-panel.lozenge.label.updated',
		defaultMessage: 'UPDATED',
		description: 'A label indicating that this feature has been updated',
	},
});
